import React from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import { format } from 'date-fns';

function DetallesClienteFactura({ factura }) {
    console.log('Datos obtenidos de factura', factura);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Los meses son de 0 a 11
        const year = date.getUTCFullYear();
        return `${day}/${month}/${year}`;
    };

    return (
        <Row className='print-flex'>
            <Col md={8} className='print-half'>
                <Table responsive size='sm' bordered className='shadow-none'>
                    <tbody>
                        <tr>
                            <th className='bg-dark-subtle'>Señores</th>
                            <td colSpan='3'>{factura.nomCliente}</td>
                        </tr>
                        <tr>
                            <th className='bg-dark-subtle'>NIT</th>
                            <td>{factura.clienteID}</td>
                            <th className='bg-dark-subtle'>Teléfono</th>
                            <td>{factura.numCliente}</td>
                        </tr>
                        <tr>
                            <th className='bg-dark-subtle'>Dirección</th>
                            <td>{factura.direccion}</td>
                            <th className='bg-dark-subtle'>Ciudad</th>
                            <td>{factura.ciudad} - {factura.departamento}</td>
                        </tr>
                    </tbody>
                </Table>
            </Col>
            <Col className='print-half'>
                <Table bordered size='sm' className='shadow-none'>
                    <tbody>
                        <tr>
                            <th className='bg-dark-subtle'>Fecha de elaboración</th>
                            <td>{formatDate(factura.creacion)}</td>
                        </tr>
                        <tr>
                            <th className='bg-dark-subtle'>Fecha de vencimiento</th>
                            <td>{formatDate(factura.vence)}</td>
                        </tr>
                    </tbody>
                </Table>
            </Col>
        </Row>
    );
}

export default DetallesClienteFactura;
